import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import { fetchSessionFromApi } from '@/shared/lib/auth/fetchSession'
import { buildPageTitle } from '@/shared/lib/page-title'
import { LandingPage } from '@/features/auth'

const landingSearchSchema = z.object({
  modal: z.enum(['sign-in', 'sign-up']).optional()
})

const LANDING_DESCRIPTION =
  'Missão Futuro — a plataforma gamificada de educação empreendedora. Jornadas, missões e recompensas para aprender brincando.'

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    try {
      const session = await fetchSessionFromApi()
      if (session) throw redirect({ to: '/jornadas' })
    } catch (err) {
      if (err && typeof err === 'object' && 'isRedirect' in err) throw err
    }
  },
  validateSearch: landingSearchSchema,
  loaderDeps: ({ search }) => ({ modal: search.modal }),
  loader: ({ deps }) => deps,
  head: ({ loaderData }) => ({
    meta: [
      {
        title: buildPageTitle(
          loaderData?.modal === 'sign-in'
            ? 'Entrar'
            : loaderData?.modal === 'sign-up'
              ? 'Criar Conta'
              : undefined
        )
      },
      { name: 'description', content: LANDING_DESCRIPTION }
    ]
  }),
  component: LandingPage
})
